import { getState } from '~src/state';
import $ from 'jquery';

export const loadSelectTags = (imageItemId) => {
  const currentTag = getState('sidebarCurrentImagesTag', 'NO_TAG');
  const allTags = window.editorConfig.sidebarTags.items;
  let data;
  if (imageItemId) {
    const imageItem = window.editorConfig.sidebarImages[currentTag].items.find(
      (item) => item.objectId === imageItemId
    );

    data = allTags.map((tag) => {
      return {
        id: tag.objectId,
        text: tag.name,
        disabled: imageItem.tags.some(
          (imageTag) => imageTag.objectId === tag.objectId
        ),
      };
    });
  } else {
    data = allTags.map((tag) => {
      return {
        id: tag.objectId,
        text: tag.name,
      };
    });
  }

  [
    '#tagImageSelectUpload',
    '#tagImageSelect',
    '#select-ricerca-immagini',
  ].forEach((selector) => {
    const isSelect2Init = $(selector).data('select2-id');
    if (!isSelect2Init) {
      $(selector).select2({
        data,
        tags: false,
        allowClear: true,
        width: '100%',
        theme: 'bootstrap4',
        placeholder: 'Seleziona un tag',
      });
    }
  });
};
